import { LibraryIssue } from '../../../../common/interfaces/Issue'
import dayjs from 'dayjs'

export const filterIssues = (
  issues: LibraryIssue[],
  issueTitle: string | undefined | null,
  startDate: Date | undefined | null,
  endDate: Date | undefined | null
): LibraryIssue[] => {
  let updatedIssues: LibraryIssue[]

  if (startDate && endDate) {
    const dateFormat = 'YYYY/MM/DD'
    const sDate = dayjs(startDate).format(dateFormat)
    const eDate = dayjs(endDate).format(dateFormat)
    const filteredIssues = issues.filter((p) => {
      const publishDate = dayjs(p.issueDate).format(dateFormat)
      if (
        dayjs(sDate) <= dayjs(publishDate) &&
        dayjs(publishDate) <= dayjs(eDate)
      ) {
        return p
      }
      return false
    })
    updatedIssues = filteredIssues.filter((p) =>
      issueTitle ? p.magTitle === issueTitle : p
    )
  } else {
    updatedIssues = issues.filter((p) =>
      issueTitle ? p.magTitle === issueTitle : p
    )
  }

  return updatedIssues
}
